import { buildDiscoverySearchLocation } from "./marketSearchState.shared";
import type { RangeValue } from "@sellar-io/components";
import type { FilterCategoryKey } from "~/components/marketSearch/marketSearchFilters";
import {
  initialDiscoveryV2SearchStoreState,
  type ContainerType,
  type OrderByType,
} from "../v2/DiscoveryV2SearchStore";

export type ProductCategoryPreset = {
  categoryKey: FilterCategoryKey;
  styleSearchValues?: readonly string[];
  containerTypes?: readonly ContainerType[];
  abvRange?: RangeValue;
  orderBy?: OrderByType;
};

export const applyProductCategoryPreset = (preset: ProductCategoryPreset) => ({
  ...initialDiscoveryV2SearchStoreState,
  categoryKey: preset.categoryKey,
  styleSearchValues: [...(preset.styleSearchValues ?? [])],
  selectedContainerTypes: [...(preset.containerTypes ?? [])],
  abvRange: preset.abvRange,
  orderBy: preset.orderBy ?? initialDiscoveryV2SearchStoreState.orderBy,
});

export const buildProductCategoryPresetLocation = (
  preset: ProductCategoryPreset,
) => buildDiscoverySearchLocation(applyProductCategoryPreset(preset));
